import { BaseText, Button, theme } from 'aimo-ui';
import { useLeaveWaitingList } from 'hooks/useLeaveWaitingList';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { ContainerWithGap, StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const LeaveWaitingListModal = () => {
  const { t } = useTranslation();
  const { leaveWaitingList, loading } = useLeaveWaitingList();

  const handleLeaveWaitingList = async () => {
    const id = usePermitStore.getState().selectedPermit!;
    await leaveWaitingList(id);
  };

  return (
    <ContainerWithGap>
      <StyledWrapper mt={20}>
        <BaseText center color={theme.colors.gray400}>
          {t('longTermParking.waitingList.confirmLeave')}
        </BaseText>
      </StyledWrapper>
      <Button
        disabled={loading}
        loading={loading}
        size="l"
        text={t('longTermParking.waitingList.leave')}
        onPress={handleLeaveWaitingList}
      />
      <Button
        disabled={loading}
        buttonType="tertiary"
        size="l"
        text={t('button.cancel')}
        onPress={() => useUiStore.getState().setSheetModal('')}
      />
    </ContainerWithGap>
  );
};
export default LeaveWaitingListModal;
